import { Database, SpreadsheetHeader, SpreadsheetType } from '../types'

function getConfigHeader(database: Database): SpreadsheetHeader[] {
    const headerConfig = [] as SpreadsheetHeader[]
    headerConfig.push({
        name: '__uid',
        alias: '__uid',
        isDisabled: false,
        isKey: false,
        isNotNull: false,
        type: SpreadsheetType.string,
        validators: []
    })

    headerConfig.push({
        name: 'file_name',
        alias: 'file_name',
        isDisabled: false,
        isKey: false,
        isNotNull: false,
        type: SpreadsheetType.string,
        validators: []
    })

    if (database.skipRealtime) {
        headerConfig.push({
            name: '__skiprealtime',
            alias: '__skiprealtime',
            isDisabled: false,
            isKey: false,
            isNotNull: false,
            type: SpreadsheetType.string,
            validators: []
        })
    }

    return headerConfig
}
export { getConfigHeader }
